export default "images/chongqing.png";